module.exports = __webpack_public_path__ + "img/block_1.61b96dfa.webp";